import DocViewShell from "@/components/DocViewShell";
import LongPestelBlueprint from "@/components/blueprints/LongPestelBlueprint";

export default function LongPestelView() {
  return (
    <DocViewShell
      eyebrow="LoNG PESTEL Analysis"
      eyebrowClass="text-indigo-700"
      toolName="LoNG PESTEL Analysis"
      maxWidth="max-w-5xl"
      editPathFn={(id) => `/pestel/${id}`}
      render={(doc) => <LongPestelBlueprint doc={doc} />}
    />
  );
}
